
import { computed, defineComponent } from 'vue';
import useConfig from '@/composables/useConfig'

import { Feature, FeatureMeasurability } from '@/composables/useConfig/features'

export default defineComponent({

	setup() {

		const config = useConfig()
		const data_first_values = config.dataset.data_first_rows[config.dataset.context.first_row_is_header ? 1 : 0];

		if (config.features === null)
		{
			// data_header_names is first row if first_row_is_header, else it is null.
			// data_first_values is second row if first_row_is_header, else first row.
			let data_header_names = config.dataset.context.first_row_is_header ? config.dataset.data_first_rows[0] : null;

			if (data_header_names == null)
			{
				data_header_names = []
				for (let i = 0; i < data_first_values.length; i++)
				{
					data_header_names.push(`Feature ${i+1}`)
				}
			}
			
			// for (const [feature_i, feature_name] of data_header_names.entries()) {
			// 	const feature: Feature = {
			// 		index: feature_i,
			// 		name: feature_name,
			// 	}
			// 	config.features.push(feature)
			// }
			data_header_names.forEach((feature_name, feature_i) => {
				if (config.features == null) config.features = []

				const feature: Feature = {
					enabled: true,
					index: feature_i,
					name: feature_name,
					is_dependant: feature_i == 0,
					measurability: FeatureMeasurability.Continuous,
				}
				config.features.push(feature)
			})
		}

		// if (config.features !== null)
		// {
		// 	config.features
		// }

/*
		const check_enabled_all = computed(() => {
			// console.log("_all", config.features?.every(x => x.enabled))
			return config.features?.every(x => x.enabled) ?? false
		})
*/
		return {
			config,
			FeatureMeasurability,
			data_first_values,

			console: computed(() => console),

			check_enabled_changed: (e: Event) => {
				const target = <HTMLInputElement>e.target;
				
				config.features?.every(x => {
					// console.log("every ", target.checked, x);
					x.enabled = target.checked
					return true;
				})

			},

			check_enabled_all: computed(() => {
				// console.log("_all", config.features?.every(x => x.enabled))
				return config.features?.every(x => x.enabled) ?? false
			}),

		}

	}
	
});
